import { updateEntity } from '@hozana/api/actions'

import type { TPublication } from './types'

export const updatePublication = (id: number, data: Partial<TPublication>) => updateEntity('publication', id, data)
